<template>
  <div class="classDiv">
    <div style="padding-bottom: 60px">
      <header>
        <div class="headerDiv" v-on:click="backHistory"  @click="">
          <img src="@/assets/img/back.png" alt="">
          <p style="color: #FFFFFF">现金券购买</p>
        </div>
      </header>
    </div>

    <!--<van-sidebar style="height: 100%" v-model="activeKey">-->
    <!--<van-sidebar-item title="标签名称" />-->
    <!--<van-sidebar-item title="标签名称" />-->
    <!--<van-sidebar-item title="标签名称" />-->
    <!--</van-sidebar>-->
    <div style="height: 90%;margin: 0 1rem;" >
      <van-radio-group v-model="radio">
        <div class="coupons" v-for="(item,key) in list">
          <div class="" @click="clickRadio(item)">
            <van-radio :name="item.id"></van-radio>
          </div>
          <div class="couponsDiv">
            <!--<van-radio name="1">单选框 1</van-radio>-->
            <div  class="couponsImg" :style="style">
            <!--<div :style="" >-->
              <div class="couponsDivLeft">
                <p style="color: #FAEBC7"><span>￥</span><span style="font-size: 24px">{{item.original_price}}</span><span>元</span></p>
              </div>
              <div class="couponsDivRight">现金券</div>
            </div>
            <p style="padding-top: 5px;color: red"><span>{{item.price}}</span><span style="font-size: 12px">元购买</span></p>
          </div>
        </div>


        <!--<van-radio name="2">单选框 2</van-radio>-->
      </van-radio-group>

    </div>
    <div class="inforName">
      <!--<van-button class="saveBottom" style=""  type="primary" @click="saveCart">确定11</van-button>-->
      <div class="saveBottom" @click="couponsOrder">支付</div>
    </div>
  </div>
</template>

<script>
  import pic from '@/assets/img/coupons.png'
  export default {
    data () {
      return {
        all:false,
        activeKey:1,
        active: 0,
        items: [
//          { text: '分组 1',id:0 }, { text: '分组 2',id:2 }
        ],
        list:[],
        codeId:"",
        radio:"",
        item:[],
        style:{
          backgroundImage:`url(${pic})`
        },
      }
    },
    methods: {
      backHistory(){
        this.$router.push("/")
      },
//      toClass(item){
//        console.log(item)
//        this.$router.push({
//          path:"/classification",
//          query:{
//            id:item.id,
//            text:item.title
//          }
//        })
//      },

      // 选中单个商品

      homeClass(){//分类
        this.$api.selectCouponList({
//          id:1
        })
          .then(res=>{
            this.list=res.data
            console.log(this.list)
//            res.data.forEach(item=>{
//              this.items.push({text:item.title,id:item.id})
//            });
//            this.onChange(0)
          })
      },
      clickRadio(item){
        this.item=item
        console.log(this.item)
//        alert(this.radio)
      },
      couponsOrder(){//分类
        this.$api.insertOrder({
          "goods_id":this.item.id,
          "goods_spec_id":this.item.goods_spec_id,
          "stock":1,
          "user_id":localStorage.getItem("userid"),
          "is_coupon":1,
        })
          .then(res=>{
            this.list=res.data
            if(res.status==200){
              localStorage.setItem("order",res.order_on)
              this.$router.replace({
                path:"/pay",
                query:{
                  id:this.item.price,
                  order:res.order_on
                }
              })
            }
            console.log(this.list)
//            res.data.forEach(item=>{
//              this.items.push({text:item.title,id:item.id})
//            });
//            this.onChange(0)
          })
      },
//      onChange(index){
//        let substationCode = this.items[index].id
//        this.$api.shopclassification({
//          id:substationCode
//        })
//          .then(res=>{
//            this.list=res.data
//
//          })
//      }
    },
    mounted(){
      this.homeClass()

//     this.homeClassRight()
    },

  }
</script>
<style  scoped="">
  *{
    /*overflow-x:hidden;*/
    padding: 0;
    margin: 0;
  }
  .go{
    position: fixed;
    top: 70%;
    right: 10px;
  }
  .classDiv{
    width: 100%;
    height: 100%;
    background: #ECECEC;
  }
  header{
    width: 100%;
    height: 50px;
    background:#ff2500 ;
    position: fixed;
    z-index: 200;
    top: 0;
  }
  header img{
    width: 18px;
    height: 18px;
    padding-left: 10px;
  }
  .headerDiv{
    display: flex;
    align-items: center;
    line-height: 50px;
  }
  .headerDiv p{
    margin: auto;
    font-size: 15px;
  }
  /deep/.van-sidebar-item{
    text-align: center;
    padding: 15px 0;
  }

  .activeImgDiv img{
    width: 50px;
    border-radius: 1rem;
  }
  .activeDiv{
    width: 25%;
    display: inline-block;
    text-align: center;
    padding: 10px;
  }
  .activeDiv span{
    display: inline-block;
    padding-top: 8px;
    white-space: nowrap;
    font-size: 12px;
  }
  h3{
    padding: 8px;
  }
  .couponsDiv{
    width: 100%;
    /*height: 80px;*/
    /*background-image: url("../../assets/img/coupons.png");*/
    background-size: 100% 100%;
    margin-left: 10px;
  }
  .coupons{
    display: flex;
    align-items: center;
    padding: 10px 10px 5px;
    background: #fff;
  }
  .couponsImg{
    width: 100%;
    height: 80px;
    /*background-image: url("../../assets/img/coupons.png");*/
    /*background-image: `url(${pic})`;*/
    background-size: 100% 100%;
    display: flex;
  }
  .couponsDivLeft{
    width: 105px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .couponsDivRight{
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 33px;
    color: #FAEBC7;
  }
  .inforName{
    position: fixed;
    bottom: 3px;
    width: 100%;
  }
  .saveBottom{
    width: 100%;
    height: 3rem;
    margin: 0 auto;
    border-radius: 1rem;
    background: -webkit-gradient(linear,left bottom, left top,from(#ff8600),to(#d42300));
    background: linear-gradient(to top,#ff8600,#d42300);
    text-align: center;
    line-height: 3rem;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/buyCoupons.vue